import type { AccountApi } from "@hostdock/sdk";
import type { SessionRestriction } from "@hostdock/types";
import { AuthLayout } from "../shell";
import { MfaEnrollment } from "./mfa";
import { ChangePasswordForm } from "./password";

/** Blocks the app until a mandatory security step is completed. */
export function RestrictedGate<TSession>({
  product,
  restriction,
  api,
  onResolved,
  onLogout,
}: {
  product: string;
  restriction: SessionRestriction;
  api: AccountApi<TSession>;
  onResolved(): void;
  onLogout(): void;
}) {
  return (
    <AuthLayout
      product={product}
      footer={
        <button type="button" onClick={onLogout} className="hover:text-fg">
          Sign out
        </button>
      }
    >
      {restriction === "PASSWORD_CHANGE_REQUIRED" ? (
        <div className="flex flex-col gap-4">
          <div>
            <h1 className="text-[17px] font-semibold">Set a new password</h1>
            <p className="mt-1 text-[13px] text-muted">You signed in with a temporary password. Choose your own password to continue.</p>
          </div>
          <ChangePasswordForm api={api} onChanged={onResolved} submitLabel="Save password" />
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <div>
            <h1 className="text-[17px] font-semibold">Set up two-factor authentication</h1>
            <p className="mt-1 text-[13px] text-muted">Your organisation requires two-factor authentication for this account.</p>
          </div>
          <MfaEnrollment api={api} onDone={onResolved} />
        </div>
      )}
    </AuthLayout>
  );
}
